module.exports = __webpack_public_path__ + "img/-badge.af8b5f8d.png";